import { Loader2 } from "lucide-react";

export default function ValidationProgressBar({ progress, isActive }) {
    if (!isActive) return null;

    return (
        <div className="mt-3 p-3 bg-gradient-to-r from-blue-50/50 to-indigo-50/50 rounded-lg border border-blue-200/30 animate-fadeIn">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                    <Loader2 size={14} className="text-blue-600 animate-spin" />
                    <span className="font-semibold text-xs text-blue-900">Validating Pages...</span>
                </div>
                <span className="text-xs font-medium text-blue-700">
                    {progress.totalPages > 0 ? `${progress.currentPage} / ${progress.totalPages}` : 'Starting...'}
                </span>
            </div>
            <div className="w-full bg-blue-200/30 rounded-full h-1.5 mb-2 overflow-hidden">
                <div
                    className="bg-gradient-to-r from-blue-500 to-blue-600 h-1.5 rounded-full transition-all duration-500 ease-out"
                    style={{
                        width: `${progress.totalPages > 0
                            ? (progress.currentPage / progress.totalPages) * 100
                            : 10}%`
                    }}
                />
            </div>
            {progress.currentPageName && (
                <div className="text-xs text-blue-700 font-normal truncate">
                    {progress.currentPageName}
                </div>
            )}
        </div>
    );
}
